import { ComposerPrimitive, MessagePrimitive } from '@assistant-ui/react';
import { Button } from '@mantine/core';
import { IconPencilCheck, IconX } from '@tabler/icons-react';

import classes from './Thread.module.css';
import { Bubble } from '#plugin-chat/components/bubble/Bubble.tsx';

/** Inline composer for editing existing messages with cancel/update actions. */
export function EditComposer() {
  return (
    <MessagePrimitive.Root className={classes.messageContainer} data-role="user">
      <ComposerPrimitive.Root>
        <div className={classes.contentWrapper}>
          <Bubble role="user">
            <div className={classes.editForm}>
              <ComposerPrimitive.Input autoFocus className={classes.editComposer} maxRows={10} rows={3} />
              <div className={classes.editActions}>
                <ComposerPrimitive.Cancel asChild>
                  <Button leftSection={<IconX size={14} />} size="xs" variant="transparent">
                    Cancel
                  </Button>
                </ComposerPrimitive.Cancel>
                <ComposerPrimitive.Send asChild>
                  <Button leftSection={<IconPencilCheck size={14} />} size="xs" variant="white">
                    Update
                  </Button>
                </ComposerPrimitive.Send>
              </div>
            </div>
          </Bubble>
        </div>
      </ComposerPrimitive.Root>
    </MessagePrimitive.Root>
  );
}
